import React, {Component} from 'react';
import { FormattedMessage } from 'react-intl';
import ScrollAnimation from 'react-animate-on-scroll';
import Button from './../../components/button/Button';
import Landpage3 from './../../assets/img/landpage3.png';
import NavigationBar from './../../components/navigationBar/NavigationBar';

import styles from './MapScreen.module.css';
import StoreUrls from './../../assets/json/storeUrls';

class MapScreen extends Component {

    constructor(props){
        super(props);
        this.goToStore = this.goToStore.bind(this);
        this.renderPortrait = this.renderPortrait.bind(this);
        this.renderLandscape = this.renderLandscape.bind(this);

        window.scrollTo(0,0);
    }

    goToStore(){
        window.location = "descubra-manaus://br.gov.am.manaus.descubra";
        setTimeout(function () {
            if ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPad") != -1) ||
                (navigator.platform.indexOf("iPod") != -1)){
                window.location = StoreUrls.appStore;
            }else{
                window.location = StoreUrls.googlePlay;
            }
        }, 1000);
    }

    renderPortrait(){
        return (
            <div className={[styles.section, styles.sectionWhite].join(' ')}>
                <div className={[styles.titleSection, styles.titlePadding].join(' ')}>
                    <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={0}>
                        <span className={styles.title}>
                            <FormattedMessage id="landPageMap" />
                        </span>
                    </ScrollAnimation>
                </div>
                <div className={styles.descriptionSection}>
                    <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={0}>
                        <span className={styles.description}>
                            <FormattedMessage id="landPageMapDesc" />
                        </span>
                    </ScrollAnimation>
                </div>
                <div className={styles.buttonSection}>
                    <Button onClick={this.goToStore}>
                        <FormattedMessage id="downloadAppSmall" />
                    </Button>
                </div>
                <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" offset={0}>
                    <div className={styles.image3}>
                        <img src={Landpage3}/>
                    </div>
                </ScrollAnimation>
            </div>
        );
    }

    renderLandscape(){
        return (
            <div className={[styles.sectionLandpage, styles.sectionWhite].join(' ')}>
                <div>
                    <div className={[styles.titleSectionLandscape, styles.titlePadding, styles.titleLandscape].join(' ')}>
                        <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={0}>
                            <span className={styles.titleLandscape}>
                                <FormattedMessage id="landPageMap" />
                            </span>
                        </ScrollAnimation>
                    </div>
                    <div className={[styles.descriptionSectionLandscape, styles.descriptionLandscape].join(' ')}>
                        <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={0}>
                            <span className={styles.descriptionLandscape}>
                                <FormattedMessage id="landPageMapDesc" />
                            </span>
                        </ScrollAnimation>
                    </div>
                    <div className={styles.buttonSectionLandscape}>
                        <Button onClick={this.goToStore}>
                            <FormattedMessage id="downloadAppSmall" />
                        </Button>
                    </div>
                </div>
                <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" offset={0}>
                    <div className={styles.image3Landscape}>
                        <img src={require('./../../assets/img/landpage3Desktop.png')}/>
                    </div>
                </ScrollAnimation>
            </div>
        );
    }

    render(){

        let screen;
        if(window.matchMedia("(orientation: landscape)").matches){
            screen = this.renderLandscape();
        }else{
            screen = this.renderPortrait();
        }

        return (
            <div>
                <NavigationBar history={this.props.history} fixed={true} active={"ar"}/>

                <div className={styles.fullPage}>
                    {screen}
                </div>

            </div>
        );
    }

}

export default MapScreen;